import { BadgeContainer, BadgeText, BadgeIcon } from "./Badge.styled";

const Badge = ({
  colorScheme,
  children,
  icon,
  isRotate = true,
  textVariant = "medium",
}) => {
  return (
    <BadgeContainer colorScheme={colorScheme}>
      {icon && <BadgeIcon isRotate={isRotate}>{icon}</BadgeIcon>}
      <BadgeText textVariant={textVariant}>{children}</BadgeText>
    </BadgeContainer>
  );
};

export default Badge;
